import React from "react";
import { authUser } from "../../services/ServiceApi";
import { useSelector } from "react-redux";

const GoBack = ({ className }) => {
  const { locale } = authUser();
  const { masterLang: language, factUpdate } = useSelector(
    (state) => state.masterLang
  );

  return (
    <div
      className={className ? className : `c-gray`}
      onClick={() => {
        window.history.length <= 1 ? window.close() : window.history.back();
      }}
      style={{ cursor: "pointer" }}
    >
      <i className="fas fa-chevron-left"></i>
      {window.history.length <= 1 ? (
        <span className="ml-2">
          {factUpdate ? language[locale]["btn_close"] : `Close`}
        </span>
      ) : (
        <span className="ml-2">
          {factUpdate ? language[locale]["btn_back"] : `Back`}
        </span>
      )}
    </div>
  );
};

export default GoBack;
